module.exports = __webpack_public_path__ + "static/img/buy_more_chances.203a9a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/buy_more_chances.png
// module id = OgOv
// module chunks = 1